import config from 'App/babel/config';

export const getVoiceRecordingUrl = (conversationUrl: string, integrationId: number) =>
	`${config.URL}${config.API}function/voice/recording/?id=${conversationUrl}&type=recording&integrationId=${integrationId}`;
